module.exports = __webpack_public_path__ + "img/tag.b5a2a59a.png";